import { LIVE_GAMES_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TLiveGamesSelector, TEqualityFunction } from '../types';

export const useLiveGamesSelector = <TSelected>(
    selector: TLiveGamesSelector<TSelected>,
    equalityFn?: TEqualityFunction<TSelected>
) => {
    return useCustomSelector<TSelected, typeof LIVE_GAMES_REDUCER>(LIVE_GAMES_REDUCER, selector, equalityFn);
};
